import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect} from "react";
import {
    deletePurchase,
    fetchVendorPurchase,
    resetCreateStatus,
    resetDeleteStatus,
    resetUpdateStatus
} from "../../store/purchase-slice";
import {Role} from "../../enums/enums";
import {useDispatch, useSelector} from "react-redux";
import {useParams, useSearchParams} from "react-router-dom";
import Table from "../../components/common/table/Table";
import {getTableColumns, getTableData} from "../../models/purchaseModel";
import ActionDropdown from "../../components/actions/ActionDropdown";
import {getValidatedLimit} from "../../components/Utility";
import ImportExportPurchaseButton from "../../components/importExport/ImportExportPurchaseButton";

const PurchaseViewVendor = () => {
    const dispatch = useDispatch();
    const params = useParams();
    const [searchParams] = useSearchParams();

    const {
        items,
        fetchVendorStatus,
        createStatus,
        updateStatus,
        deleteStatus,
        pagination,
        error
    } = useSelector(state => state.purchase);
    const {limit, currentPage} = getValidatedLimit(pagination);


    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;

    const userRole = useSelector((state) => state.auth.selectedRole);

    useEffect(() => {
        if (createStatus === "success") {
            dispatch(resetCreateStatus());
        }
    }, [dispatch, createStatus]);

    useEffect(() => {
        if (updateStatus === "success") {
            dispatch(resetUpdateStatus());
        }
    }, [dispatch, updateStatus]);

    useEffect(() => {
        if (deleteStatus === "success") {
            dispatch(resetDeleteStatus());
        }
    }, [dispatch, deleteStatus]);

    const deleteHandler = (id) => {
        dispatch(deletePurchase({...userRole, id}));
    };

    useEffect(() => {
        if (params.vendorId) {
            dispatch(fetchVendorPurchase({...userRole, id: params.vendorId, page: initialPage, limit: initialLimit}));
        }
    }, [dispatch, params.vendorId, initialPage, initialLimit, userRole]);

    const tableColumns = getTableColumns({ActionDropdown, deleteHandler});
    const tableData = getTableData({items});

    return (
        <>
            <SubHeader title="Vendor Purchases">
                {userRole.role !== Role.Manager &&
                    <Button to={`/vendor/${params.vendorId}/getDue`} className="btn-sm bg-primary bg-opacity-50">Get
                        Dues</Button>}
                <Button to={`/vendor/${params.vendorId}/history`}
                        className="btn-sm bg-primary bg-opacity-50">History</Button>
                <Button to="add" className="btn-sm bg-primary bg-opacity-50">Add New</Button>
                <Button to={`../../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            {fetchVendorStatus === "loading" && <p>Loading...</p>}
            {fetchVendorStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchVendorStatus === "success" && (
                <>
                    <ImportExportPurchaseButton vendorId={params.vendorId}/>
                    <Table
                        className="mobile-responsive"
                        columns={tableColumns}
                        data={tableData}
                        pagination={pagination}
                    />
                </>
            )}
        </>
    )
}

export default PurchaseViewVendor;